import React from "react";
import ReactDOM from "react-dom";

import {AppContainer} from "react-hot-loader";

import {Provider} from "react-redux";
import store from "./store/configureStore";

import App from "./App";

import { QueryClientProvider } from "react-query";

import queryClient from "./queries/queryClient";
import { Chart } from "chart.js";
import { getCSSvar, patchIpadUserAgent } from "./helpers";

import "@fortawesome/fontawesome-free/css/all.min.css";

import './i18n';

// --- Global initialization ---

// Chart.js
Chart.defaults.global.defaultFontFamily = getCSSvar("--fonts");
Chart.defaults.global.maintainAspectRatio = false;
Chart.defaults.global.legend.position = 'bottom';

// Browser userAgent tweaking
patchIpadUserAgent();

// --- End of initialization ---

const render = (Component) => {
    ReactDOM.render(
        <QueryClientProvider client={queryClient}>
            <Provider store={store}>
                <AppContainer>
                    <Component/>
                </AppContainer>
            </Provider>
        </QueryClientProvider>,
        document.getElementById('root'),
    )
};
render(App);
if (process.env.NODE_ENV === 'development' && module.hot) {
    module.hot.accept('./App', () => {
        render(App)
    })
}



// WEBPACK FOOTER //
// ./src/index.js